import React, { useEffect, useState } from "react";
import "./addTraining.css";
import LoadingPage from "../Loading/loading";
import { Link } from "react-router-dom";
import {
  deleteTraining,
  getTrainings,
  updateTraining,
} from "../../api/training";

const TrainingComponent = (props) => {
  const [trainings, setTraining] = useState(null);
  const [id, setId] = useState("");
  const [idUpdate, setIdUpdate] = useState("");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    setTraining(null);
    getTrainings().then((result) => {
      setTraining(result.data.trainings);
    });
  }, []);

  const trainingDelete = (id) => {
    deleteTraining(id).then((result) => {
      setTraining(trainings.filter((gettraining) => gettraining._id !== id));
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const update = () => {
    setLoading(true);
    updateTraining(
      formData._id,
      formData.video,
      formData.name,
      formData.description,
    ).then((result) => {
      getTrainings().then((result) => {
        setTraining(result.data.trainings);
        setIdUpdate("");
        setFormData(null);
        setLoading(false);
      });
    });
  };

  return (
    <>
      {trainings === null ? (
        <LoadingPage />
      ) : (
        <div>
          <div className="card-cards">
            {trainings?.map((training) => (
              <div key={training._id} className={`card-card`}>
                {idUpdate === training._id ? (
                  <div style={{ width: "100%" }}>
                    <div className="form-group">
                      <label htmlFor="video">Video</label>
                      <input
                        type="text"
                        id="video"
                        name="video"
                        value={formData.video}
                        onChange={handleChange}
                        placeholder="Enter video"
                        required
                        onInvalid={(e) =>
                          e.target.setCustomValidity("Video is required")
                        }
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="name">Name</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Enter Name"
                        required
                        onInvalid={(e) =>
                          e.target.setCustomValidity("Name is required")
                        }
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="video">Description</label>
                      <input
                        type="text"
                        id="description"
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        placeholder="Enter description"
                        required
                        onInvalid={(e) =>
                          e.target.setCustomValidity("Description is required")
                        }
                      />
                    </div>

                    {loading ? (
                      <div
                        style={{
                          width: "100%",
                          justifyContent: "center",
                          display: "flex",
                        }}
                      >
                        <div className="spinner"></div>
                      </div>
                    ) : (
                      <div className="card-info">
                        <div className="card-actions">
                          <button
                            onClick={() => {
                              setFormData(null);
                              setIdUpdate("");
                            }}
                            className="action-btn remove-btn"
                          >
                            No
                          </button>
                        </div>
                        <div className="card-actions">
                          <button
                            onClick={() => {
                              update();
                            }}
                            className="action-btn accept-btn"
                          >
                            Update training
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="card-info">
                    <div>
                      <p className="line">
                        <span className="label">Name:</span> {training.name}
                      </p>
                      {id === training._id && (
                        <div
                          style={{
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            padding: "5px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <p className="line">
                            Are you sure you want to delete this training?{" "}
                          </p>
                          <div className="card-info">
                            <div className="card-actions">
                              <button
                                onClick={() => {
                                  setId("");
                                }}
                                className="action-btn accept-btn"
                              >
                                No
                              </button>
                            </div>
                            <div className="card-actions">
                              <button
                                onClick={() => {
                                  trainingDelete(training._id);
                                }}
                                className="action-btn remove-btn"
                              >
                                Yes
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {id !== training._id && idUpdate !== training._id && (
                  <div className="card-actions">
                    <Link
                      target="_blank"
                      to={training.video}
                      className={`action-btn accept-btn`}
                    >
                      Video
                    </Link>
                    {props.isSuper && (
                      <>
                        <button
                          onClick={() => {
                            setFormData(training);
                            setIdUpdate(training._id);
                          }}
                          className="action-btn ban-btn"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => {
                            setId(training._id);
                          }}
                          className="action-btn remove-btn"
                        >
                          Delete
                        </button>
                      </>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default TrainingComponent;
